export default __webpack_public_path__ + "static/media/file-excel.ddae2147.svg";